import EventEmitter from 'event-emitter';
import log from 'loglevel';
/**
 * 撤销重做管理器
 * 该撤销，重做的机制是缓存当前页面的数据操作内容，当翻页的时候会清空，有别于Cache.js的实现
 * Cache 是缓存每页的最后的一个状态镜像， 这里缓存的是最大步数内每步的镜像数据
 *
 * @export
 * @class UndoManager
 * @author zhenliang.sun
 */
export default class UndoManager {
  constructor() {
    if (this._instance) {
      throw new Error('UndoManager is singlton');
    }
    EventEmitter(this);
    this._instance = this;
    // 数据存储器
    this._dataCache = [];
    // 索引
    this._currentIndex = 0;
    // 最大缓存数量
    UndoManager.MAX_CACHE_COUNT = 10;
  }

  static getInstance() {
    if (!this._instance) {
      this._instance = new UndoManager();
    }

    return this._instance;
  }

  /**
   * 撤销
   *
   * @memberof UndoManager
   */
  undo() {
    if (!this.canUndo()) {
      return;
    }

    this._currentIndex -= 1;
    this.emitStepChange();

    return this._dataCache[this._currentIndex];
  }

  /**
   * 重做
   *
   * @memberof UndoManager
   */
  redo() {
    if (!this.canRedo()) {
      return;
    }

    this._currentIndex += 1;
    this.emitStepChange();

    return this._dataCache[this._currentIndex];
  }

  /**
   * 清空， 重置
   *
   * @memberof UndoManager
   */
  clear() {
    this._currentIndex = -1;
    this._dataCache = [];
  }

  /**
   * 添加数据
   *
   * @param {any} data
   * @memberof UndoManager
   */
  save(data) {
    // 移除旧数据
    // while (this._dataCache.length > UndoManager.MAX_CACHE_COUNT) {
    //   this._dataCache.shift();
    // }
    // 重置索引
    this._currentIndex = Math.min(this._currentIndex, this._dataCache.length - 1);
    // 重置数据缓存
    this._dataCache = this._dataCache.slice(0, this._currentIndex + 1);
    this._dataCache.push(data);
    this._currentIndex += 1;
    this.emitStepChange();
  }

  /**
   * 是否能够撤销
   *
   * @memberof UndoManager
   */
  canUndo() {
    return this._currentIndex > -1;
  }

  /**
   * 是否能够撤销
   *
   * @memberof UndoManager
   */
  canRedo() {
    return this._currentIndex < this._dataCache.length - 1;
  }
  emitStepChange() {
    this.emit('undo_step_change', {
      undoStep: Math.max(this._currentIndex, 0),
      redoStep: this._dataCache.length - 1 - this._currentIndex
    });
  }
}
